<template>
    <div class="page bg-transfer-point relative desktop-footer">
        <div class="bg-head-coin hidden sm:block"></div>
        <div class="page-content sm:px-8 pb-10">
            <TopBar class="hidden sm:block" :modalController="modalController"></TopBar>
            <TopBarBack class="block sm:hidden bg-a-blue-1c3e95 rounded-t-25" :isShowPoint="false" routeBack="/profile"></TopBarBack>
            <MenuDesktop activeMenu="none"></MenuDesktop>
            <div class="mx-auto sm:pb-0 bg-white sm:rounded-25 sm:mt-4">
                <div class="text-a-blue-1c3e95 text-24 text-center pt-4">{{lbl.transfer.head}}</div>
                <div class="mx-6 mt-4">
                    <!-- Point -->
                    <PointLabel class="w-140px mx-auto"></PointLabel>
                    <FormTransferPoint class="mt-20" ref="form-transfer-point"></FormTransferPoint>
                    <div class="flex justify-center pb-8">
                        <BlueBtn class="mt-5 text-20 sm:w-80" @click="onclickSubmit()">{{lbl.transfer.head}}</BlueBtn>
                    </div>
                </div>
            </div>
        </div>
        <div class="block sm:hidden w-full">
            <div class="absolute left-0 right-0 bottom-1">
                <div class="flex justify-center">
                    <img class="w-40" src="@/assets/poer-tip.png">
                </div>
            </div>
        </div>
        <BottomBar></BottomBar>
        <ModalMaster :controller="modalController"></ModalMaster>
    </div>
</template>

<script>
//mixins
import ModalMixin from '@/mixin/ModalMixin.js';
import TranferPointService from '../service/TranferPointService.js'
//components
import TopBarBack from '@/components/Layout/TopBar/TopBarBack.vue';
import TopBar from '@/components/Layout/TopBar/TopBar.vue';
import MenuDesktop from '@/components/Layout/MenuDesktop/MenuDesktop.vue';
import BottomBar from '@/components/Layout/BottomBar/BottomBar.vue';
import PointLabel from '../component/PointLabel.vue';
import FormTransferPoint from '../component/FormTransferPoint.vue';
import BlueBtn from '@/components/Button/BlueBtn.vue'
import LocaleMixin from '@/mixin/LocaleMixin.js';
export default {
    name: 'TransferPoint',
    mixins: [ModalMixin, LocaleMixin],
    components:{
        TopBarBack,
        TopBar,
        MenuDesktop,
        BottomBar,
        PointLabel,
        FormTransferPoint,
        BlueBtn
    },
    data() {
        return {

        };
    },

    mounted() {
        // this.modalController.alertTranfersPointModal.show();
    },

    methods: {
        onclickSubmit: function(){
            let data = this.$refs['form-transfer-point'].validateForm();
            if(data){
                let msg = this.lbl.transfer.confirm_desc + data.point + this.lbl.transfer.text_point;
                this.modalController.confirmModal
                    .clearModal()
                    .setTitle(this.lbl.transfer.confirm_tranfer)
                    .setMsg(msg)
                    .setBtnOk(this.lbl.transfer.confirm)
                    .setBtnCancel(this.lbl.transfer.cancel)
                    .show();
                 this.modalController.confirmModal.onClickOk(async () => {
                    let params = {
                        contact_number: data.contactNumber,
                        points: data.point
                    }
                    this.modalController.loadingModal.show();
                    await this.apiTranferPoint(params)
                    this.modalController.loadingModal.hide();
                });
            }else{
                console.log('fail')
            }
        },
        apiTranferPoint: function(params){
            return new Promise((resolve) => {
                TranferPointService.postTransferPoints(params)
                    .subscribe({
                        next: (res) => {
                            this.modalController.alertTranfersPointModal.show();
                            resolve(res);
                        },
                        error: (err) => {
                            this.modalController.alertModal
                                .clearModal()
                                .setMsg(err.message)
                                .show()
                            resolve(null);
                        }
                    });
            });
        }
    },
};
</script>

<style lang="scss" scoped>
@import "@/style/base/base.scss";
.bg-transfer-point {
    background-image: linear-gradient(to bottom, #1c3e95 2%, #1c3d91 2%, #1a326e 16%);
    @include mobile {
        // background-color: #e9ecf5;
        background-color: white;
        background-image: none;
    }
}
.logo-padding{
    padding-top: 15%
}
</style>

